<template>
  <div class="card shadow-sm">
    <div class="card-body">
      <div v-if="hasData">
        <table class="table table-sm">
          <tr>
            <th>Panel</th>
            <td>{{ item.panel.name }}</td>
          </tr>
          <tr>
            <th>{{ $t('dmp.event') }}</th>
            <td>{{ item.data.description }}</td>
          </tr>
          <tr>
            <th>{{ $t('dmp.device') }}</th>
            <td>{{ item.data.deviceId }} - {{ item.data.deviceName }}</td>
          </tr>
          <tr>
            <th>{{ $t('dmp.deviceType') }}</th>
            <td>{{ item.data.deviceType }}</td>
          </tr>
          <tr>
            <th>{{ $t('dmp.area') }}</th>
            <td>{{ item.data.area }}</td>
          </tr>
          <tr>
            <th>User</th>
            <td>{{ item.data.user }}</td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { computed } from "@vue/composition-api";

export default {
  name: "AlarmBridgeLogDeviceItem",
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const hasData = computed(() => {
      return props.item.data !== undefined && Object.keys(props.item.data).length > 0;
    });

    return {
      hasData,
    };
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/scss/variables/_variables.scss";

.comment-content {
  //background-color: #f8f9fa;
  padding: 1.25rem;
  border-radius: 0.5rem;
  .dark-layout & {
    background-color: $second-dark !important;
    border: 1px solid darken($second-dark, 5%);
  }
}

.comment-text {
  line-height: 1.6;
  color: #343a40;
  .dark-layout & {
    color: $theme-dark-label-color !important;
  }
}

.card-body {
  padding: 0.5rem !important;
}

.comment-author {
  border-top: 1px solid #e9ecef;
  padding-top: 1rem;
  margin-top: 1rem;
}

.author-name {
  font-weight: 600;
  color: #343a40;
  .dark-layout & {
    color: $theme-dark-label-color !important;
  }
}

.author-email {
  font-size: 0.85rem;
}
</style>
